"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sumDeviceMotion = void 0;

var _share = require("../Observables/share");

var _scan = require("../Observables/scan");

var _map = require("../Observables/map");

var smallD = function smallD(a, b) {
  var d = a - b;

  if (d < 0.1) {
    return 0;
  } else {
    return d;
  }
};

var sumDeviceMotion = function sumDeviceMotion(deviceMotion$) {
  return deviceMotion$.pipe((0, _share.share)(), (0, _scan.scan)(function (_ref, a) {
    var delta = _ref.delta,
        last = _ref.last;

    if (!last) {
      return {
        delta: delta,
        last: a
      };
    }

    return {
      delta: {
        x: smallD(Math.max(last.x, a.x), Math.min(last.x, a.x)),
        y: smallD(Math.max(last.y, a.y), Math.min(last.y, a.y)),
        z: smallD(Math.max(last.z, a.z), Math.min(last.z, a.z))
      },
      last: a
    };
  }, {
    delta: {
      x: 0,
      y: 0,
      z: 0
    },
    last: null
  }), (0, _map.map)(function (x) {
    return x.delta;
  }), (0, _scan.scan)(function (acc, a) {
    return {
      x: acc.x + a.x,
      y: acc.y + a.y,
      z: acc.z + a.z
    };
  }, {
    x: 0,
    y: 0,
    z: 0
  }));
};

exports.sumDeviceMotion = sumDeviceMotion;